'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'user-bounty-hunter';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'e2bf';
var svgPathData = ['M32.2 480l105.2 0L207 410.3c9.4-9.4 24.6-9.4 33.9 0L310.6 480l105.2 0c-3.3-53.6-47.8-96-102.2-96l-179.2 0C80 384 35.5 426.4 32.2 480zM96.4 265.5l70.2 14c-4.9-29.5-22.4-52.1-41.2-68.5c-8.5-7.4-17.1-13.4-24.4-17.9l-4.7 72.4zm10-137.5L224 128l117.6 0C330.4 72.9 281.7 32 224 32s-106.4 40.9-117.6 96zM281.3 279.6l70.2-14-4.7-72.4c-7.3 4.5-15.8 10.5-24.4 17.9c-18.8 16.4-36.3 39.1-41.2 68.5z', 'M80 0C71.2 0 64 7.2 64 16l0 248c0 1 .1 2 .3 3l-.2 3.5c-.8 12 7.5 22.7 19.2 25.1l114.6 22.9c16.2 3.2 36.1 3.2 52.3 0l114.6-22.9c11.8-2.4 20-13.1 19.2-25.1l-8.3-128.2C370.5 62.2 304.1 0 224 0C170.5 0 123.1 27.7 96 70l0-38c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 0zm21.1 193.1c7.3 4.5 15.8 10.5 24.4 17.9c18.8 16.4 36.3 39.1 41.2 68.5l-70.2-14 4.7-72.4zm98.5 93.1c-3.3-45.3-28.9-78.1-53.1-99.2c-13-11.4-25.9-19.7-35.6-25.2c-1.1-.6-2.1-1.2-3.1-1.7L208 160l0 127.7c-1.3-.2-2.6-.4-3.9-.7l-4.5-.9zm40.4 1.6L240 160l100.2 0c-1 .5-2 1.1-3.1 1.7c-9.7 5.5-22.6 13.9-35.6 25.2c-24.2 21.1-49.8 53.9-53.1 99.2l-4.5 .9c-1.3 .3-2.5 .5-3.9 .7zm41.3-8.2c4.9-29.5 22.4-52.1 41.2-68.5c8.5-7.4 17.1-13.4 24.4-17.9l4.7 72.4-70.2 14zM341.6 128L224 128l-117.6 0C117.6 72.9 166.3 32 224 32s106.4 40.9 117.6 96zM134.4 384l179.2 0c54.4 0 98.9 42.4 102.2 96l-105.2 0L241 410.3c-9.4-9.4-24.6-9.4-33.9 0L137.4 480 32.2 480c3.3-53.6 47.8-96 102.2-96zM224 438.6L265.4 480l-82.7 0L224 438.6zM25.6 512L144 512l160 0 118.4 0c14.1 0 25.6-11.5 25.6-25.6C448 412.2 387.8 352 313.6 352l-179.2 0C60.2 352 0 412.2 0 486.4C0 500.5 11.5 512 25.6 512z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUserBountyHunter = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;